/*
 * Searchbar component utilizing antd
 * Documentation at https://ant.design/
 */
import React, { Component } from 'react';
import axios from 'axios';
import { debounce } from 'lodash';
import {Col, Row, Select} from 'antd';

/*
 * Returns a filtered list of station names for the search bar.  For speed optimization, the results are limited by
 * default to 10 items.
 */
function get_list_of_stations( value, callback, search_limit = 10 ){
    const url = 'https://web-services.unavco.org/internalWS/gps/metadata/name/sites/beta',
        cached_stations = sessionStorage.getItem( 'stations_list' ),
        result = [];

    // Process results from web-service and returns up to search_limit
    const process_stations_results = ( data ) =>{
        let item;

        for( let i=0; i < data.length; i++ ){
            item = data[ i ];

            if( item.toLowerCase().indexOf( value.toLowerCase() ) >=0 ){
                result.push( { value : item, text: item } );

                // Exit loop if search_limit has been reached
                if( result.length > search_limit ) {
                    break
                }
            }
        }
        callback( result );
        return;
    };

    // Checks for session cache otherwise fetch data from web-services
    if( cached_stations ) {
        process_stations_results( cached_stations.split( ',' ) );
        return;
    } else {
        axios.get( url )
            .then( function( response ){
                sessionStorage.setItem( 'stations_list', response.data.stationnames );
                process_stations_results( response.data.stationnames );
            })
            .catch( function( error) {
                console.log( 'Error fetching list of stations from https://web-services.unavco.org/internalWS/gps/metadata/name/sites/beta')
                console.log( error );
            });
    }
}

/*
 * Searchbar and associated settings
 */
class SearchBar extends Component {
    constructor( props ){
        super( props );

        this.state = {
            search_results : []
        };

        // Throttle typeahead for search to increase performance
        this.handleSearch = debounce( this.handleSearch, 300 );
    }

    /*
     * Handles changes for the search input and creates a typeahead of station's 4-char-id
     */
    handleSearch = ( value ) => {
        get_list_of_stations( value, data => {
            this.setState( { search_results : data } );
        });
    }

    /*
     * Handle change events for reference frames and annotations
     */
    handleChange = ( key, value ) => {
        // Clear search results after selecting stations
        this.setState({
            search_results : []
        });

        this.props.onChange( key , value );
    }

    render() {
        // Renders the typeahead suggestion for search bar
        const search_bar_results = this.state.search_results.map( item => <Select.Option key = { item.value }>{ item.text }</Select.Option>);
        const { stations } = this.props.params;

        return (
            <Row gutter={ 0 } type="flex" justify="center">
                <Col span = { 24 }>
                    <Select
                        showSearch
                        allowClear
                        mode = "multiple"
                        value = { stations }
                        defaultActiveFirstOption = { true }
                        showArrow = { false }
                        filterOption = { false }
                        onSearch = { this.handleSearch }
                        onChange = { ( value ) => this.handleChange( 'stations', value ) }
                        notFoundContent = { null }
                        placeholder = "Enter a station's four character ID"
                        style = {{ width: '100%' }}
                    >
                        { search_bar_results }
                    </Select>
                </Col>
            </Row>
        );
    }
}

export default ( SearchBar );


// WEBPACK FOOTER //
// ./src/components/SearchBar/SearchBar.js